module.exports = __webpack_public_path__ + "static/media/Spotify_icon.aa85e25b.svg";